// TODO 把旧版本的swagger残留数据删了
import swaggerApi from './api.swagger-constants';
import { apis as apisV2 } from '@easytwin/types';

const apis = {
  ...swaggerApi,
  fileUpload: 'POST /api/fs/v1/static/{path}',

  ...apisV2,
} as const;

export type { ApiMaps } from '../type/api.types';
export default apis;
